import { Injectable } from '@angular/core';

import { BaseEditCreateCopyService } from 'tms-lib';

@Injectable({
  providedIn: 'root',
})
export abstract class TmsWebBaseEditCreateCopyService<T, TEdit> extends BaseEditCreateCopyService<T, TEdit> {
  protected constructor(baseRoute: string, name: string) {
    super(baseRoute, name);
  }

  protected get apiUrl() {
    return `TmsWeb/${this.baseRoute}`;
  }
}
